import _ from 'lodash';
import defaultConfig from './config.default';

export const devConfig = _.merge({}, defaultConfig, {});
